export default "<p style=\"position: absolute;\" class=\"has-white-text\">comida works!</p>\r\n"